var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJourney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.6C22 14.5174 20.8411 17.3153 18.7782 19.3782C16.7153 21.4411 13.9174 22.6 11 22.6C8.08262 22.6 5.28473 21.4411 3.22183 19.3782C1.15893 17.3153 0 14.5174 0 11.6C0 8.68259 1.15893 5.8847 3.22183 3.8218C5.28473 1.7589 8.08262 0.599976 11 0.599976C13.9174 0.599976 16.7153 1.7589 18.7782 3.8218C20.8411 5.8847 22 8.68259 22 11.6ZM11 5.41248C11 5.23014 10.9276 5.05527 10.7986 4.92634C10.6697 4.79741 10.4948 4.72498 10.3125 4.72498C10.1302 4.72498 9.9553 4.79741 9.82636 4.92634C9.69743 5.05527 9.625 5.23014 9.625 5.41248V12.975C9.62504 13.0962 9.65711 13.2152 9.71796 13.32C9.77881 13.4248 9.86627 13.5116 9.9715 13.5717L14.784 16.3217C14.9419 16.4071 15.127 16.4273 15.2996 16.378C15.4722 16.3287 15.6187 16.2139 15.7078 16.058C15.7969 15.9021 15.8214 15.7176 15.7762 15.5439C15.7311 15.3701 15.6197 15.221 15.466 15.1282L11 12.5762V5.41248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourney);
export default __webpack_public_path__ + "static/media/journey.03d30f3a782c835b393937ab7467e2bf.svg";
export { ForwardRef as ReactComponent };